import { PlansPage } from '@/features/plans/pages/plans-page';

const PlansRoute = () => {
  return <PlansPage />;
};

export default PlansRoute;
